import { render, staticRenderFns } from "./viewAppraiseReplies.vue?vue&type=template&id=1f9e5abb&scoped=true"
import script from "./viewAppraiseReplies.vue?vue&type=script&lang=js"
export * from "./viewAppraiseReplies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9e5abb",
  null
  
)

export default component.exports